import { useEffect, useContext, useState, useRef } from 'react';

//Constantes
import { PRIMARY_COLOR, SECUNDARY_COLOR } from '../../constants/colors.js';

//Components
import Select from 'react-select';
import FormActivo from '../FormActivo/FormActivo.jsx';

//Estilos
import './BarActivo.css'
import { ICONS2 } from '../../constants/colors.js';

//Imagenes
import qr from '../../images/qr.png';

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCaretDown, faCaretUp, faGem, faImage, faSearch, faLocationDot, faMapLocation,faBars, faArrowLeft
} from "@fortawesome/free-solid-svg-icons";
import TreeActivo from '../TreeActivo/TreeActivo.jsx';

//Contextos
import nivel1Context from '../../context/nivel1Context/nivel1Context.js';
import activoContext from '../../context/activoContex/activoContex';
import nivel2Context from '../../context/nivel2Context/nivel2Context';
import nivel3Context from '../../context/nivel3Context/nivel3Context.js';
import productosXactivoContext from '../../context/productosXactivoContex/productosXactivoContext.js';
import sistemaContext from '../../context/sistemaContex/sistemaContext.js';
import subsistemaContext from '../../context/subsistemaContex/subsistemaContext.js';
import nivel4Context from '../../context/nivel4Context/nivel4Context.js';
import nivel5Context from '../../context/nivel5Context/nivel5Context.js';
import FormDuplicateLevels from '../formDuplicateLevels/FormDuplicateLevels.js';

/* 
    Componente de barra que se expande en solapa de Activos.
*/
function BarActivo({handleOnClick, modalToShow, setModalToShow}) {
    //contex nivel1 - podes ver las nivel1 en el selec
    const {activoList} = useContext(activoContext)
   
    const lv1Context = useContext(nivel1Context);
    const {nivel1Lista} = lv1Context;

    const lv2Context = useContext(nivel2Context);
    const {nivel2List} = lv2Context;

    const lv3Context = useContext(nivel3Context);
    const {nivel3List} = lv3Context
    
    const lv4Context = useContext(nivel4Context);
    const {nivel4List} = lv4Context

    const lv5Context = useContext(nivel5Context);
    const {nivel5List} = lv5Context

    const cContex =useContext(productosXactivoContext);
    const {activoXproductoList} = cContex;
   
    const sContex =useContext(sistemaContext);
    const {sistema} = sContex;

    const subContex =useContext(subsistemaContext);
    const {subsistema} = subContex;
    
    const [isHovered, setIsHovered] = useState(false);
    const [treeDataActivo, setTreeDataActivo] =  useState();
    const [isHoveredBar, setIsHoveredBar] = useState(false);
    const [showContextualMenu,setShowContextualMenu] = useState(null);
    const [canClose, setCanClose] = useState(false);

    const barRef = useRef(null);

    const setIsHoveredBarByFlag = (flag) => {
        setIsHoveredBar(flag);
    };

    useEffect(() => {
        const handleWindowClick = (event) => {
            if (barRef.current && !barRef.current.contains(event.target) && canClose) {
                console.log("canClose");
                console.log(canClose);
                
                setIsHoveredBarByFlag(false);
                setCanClose(false);
            }
        };
        window.addEventListener('click', handleWindowClick);
        return () => window.removeEventListener('click', handleWindowClick);
    }, [canClose]);

    const handleHoveredBarEnter = () => {
        setIsHoveredBar(true);
    };

    const handleHoveredBarLeave = () => {
        setIsHoveredBar(false);
        setShowContextualMenu(null);
    };

    
    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };


    useEffect(() => {

        const getProducstsWithSistemAndSubsistem = (activo) => {
            const children = [
                ...sistema?.map(sistemaI => (
                    (activoXproductoList?.some((p) => p.sistemaID === sistemaI._id && p.activoID === activo._id)) ?
                    {
                        ...sistemaI,
                        children: [
                            ...(subsistema?.map(sbs => (
                                (activoXproductoList?.some((p) => p.subsistemaID === sbs._id && p.sistemaID === sistemaI._id && p.activoID === activo._id)) ? {
                                    ...sbs,
                                    children: [
                                        ...(activoXproductoList?.map(p => (
                                            (p.subsistemaID === sbs._id && p.sistemaID === sistemaI._id && p.activoID === activo._id) ? {...p, type:'Product'}  : null
                                        )) ?? [])
                                    ].filter(a => a),
                                    type:'Subsystem'
                                } : null
                            )) ?? [])
                        ].filter(a => a),
                        type:'System'
                    }
                    : null
                ))
            ].filter(a => a);

            return children;
        }

        let dataToDisplay = nivel1Lista?.map(l1 => ({
            ...l1,
            type:'Nivel1',
            children: [
                ...(activoList?.map(a => { 
                    return (
                    (!a.activoNivel2ID && a.activoNivel1ID == l1._id) ? {
                        ...a,                     
                        children: [
                            ...getProducstsWithSistemAndSubsistem(a)
                        ].filter(a => a),
                        type:'Activo'
                    } : null
                )}) ?? []), 
                ...nivel2List?.map(l2 => (
                    l2.nivel2Nivel1ID === l1._id ? {
                        ...l2, 
                        type:'Nivel2',
                        children: [
                            ...(activoList?.map(a => (
                                (!a.activoNivel3ID && a.activoNivel2ID == l2._id) ? {
                                    ...a,                                 
                                    children: [
                                        ...getProducstsWithSistemAndSubsistem(a)
                                    ],
                                    type:'Activo',
                                } : null
                            )) ?? []), 
                            ...nivel3List?.map(l3 => (
                                l3.nivel3Nivel2ID == l2._id ? {
                                    ...l3,
                                    type:'Nivel3',
                                    children: [
                                        ...(activoList?.map(a => (
                                            (!a.activoNivel4ID && a.activoNivel3ID == l3._id) ? {
                                                ...a,                                            
                                                children: [
                                                    ...getProducstsWithSistemAndSubsistem(a)
                                                ],
                                                type:'Activo'
                                            } : null
                                        )) ?? []),
                                        ...nivel4List?.map(l4 => (
                                            l4.nivel4Nivel3ID == l3._id ? {
                                                ...l4,
                                                type:'Nivel4',
                                                children:[
                                                    ...(activoList?.map(a => (
                                                        (!a.activoNivel5ID && a.activoNivel4ID == l4._id) ? {
                                                            ...a,                                                        
                                                            children: [
                                                                ...getProducstsWithSistemAndSubsistem(a)
                                                            ],
                                                            type:'Activo'
                                                        } : null
                                                    )) ?? []),
                                                    ...nivel5List?.map(l5 => (
                                                        l5.nivel5Nivel4ID == l4._id ? {
                                                            ...l5,
                                                            type:'Nivel5',
                                                            children: [
                                                                ...(activoList?.map(a => (
                                                                    a.activoNivel5ID == l5._id ? {
                                                                        ...a,                                                                    
                                                                        children: [
                                                                            ...getProducstsWithSistemAndSubsistem(a)
                                                                        ],
                                                                        type:'Activo'
                                                                    } : null
                                                                )) ?? [])
                                                            ].filter(a => a)
                                                        } : null
                                                    ))
                                                ].filter(a => a)
                                            } : null
                                        ))
                                    ].filter(a => a)
                                } : null
                            ))
                        ].filter(a => a)
                    } : null
                ))
            ].filter(a => a)
        }))

        for(const lv1 of dataToDisplay){
            lv1.brothers = dataToDisplay.map(ch => ({...ch}));
            // lv1.brothers = dataToDisplay.map(ch => ch._id != lv1._id).map((c,i) => ({...c, position: })); Por si tuvieramos que modelar position en caso de que no la tenga.
            let lv1Childrens = lv1.children ?? []; //Niveles 2 y Activos
            for(const chLv1 of lv1Childrens){
                chLv1.brothers = lv1Childrens.map((c,i) => ({...c, position: c.position ?? i})); 
                let lv2Childrens = chLv1.children; //Niveles 3 y Activos
                for(const chLv2 of lv2Childrens){
                    chLv2.brothers = lv2Childrens.map((c,i) => ({...c, position: c.position ?? i}));
                    let lv3Childrens = chLv2.children; //Niveles 4 y Activos
                    for(const chLv3 of lv3Childrens){
                        chLv3.brothers = lv3Childrens.map((c,i) => ({...c, position: c.position ?? i}));
                        let lv4Childrens = chLv3.children; //Niveles 5 y Activos
                        for(const chLv4 of lv4Childrens){
                            chLv4.brothers = lv4Childrens.map((c,i) => ({...c, position: c.position ?? i})); 
                            chLv4.brothers?.sort((a,b) => a.position - b.position);
                            chLv4.children?.sort((a,b) => a.position - b.position);
                        }
                        chLv3.brothers?.sort((a,b) => a.position - b.position);
                        chLv3.children?.sort((a,b) => a.position - b.position);
                    }
                    chLv2.brothers?.sort((a,b) => a.position - b.position);
                    chLv2.children?.sort((a,b) => a.position - b.position);
                }
                chLv1.brothers?.sort((a,b) => a.position - b.position);
                chLv1.children?.sort((a,b) => a.position - b.position);
            }
            lv1.brothers?.sort((a,b) => a.position - b.position);
            lv1.children?.sort((a,b) => a.position - b.position);
        }
        dataToDisplay.sort((a,b) => a.position - b.position);

        setTreeDataActivo(dataToDisplay)
    }, [activoList, activoXproductoList, nivel1Lista, nivel2List, nivel3List, nivel4List, nivel5List]);

    const [search, setSearch] = useState("");

    const handlerSearch = (text) => {
        setSearch(text);
    }

    const filterData = (data, search) => {
        let result = [];
        data?.forEach((item) => {            
          if (item?.name?.toLowerCase().includes(search.toLowerCase()) || item?.codActivo?.toLowerCase().includes(search.toLowerCase()) || 
            item?.nameNivel3?.toLowerCase().includes(search.toLowerCase())) {
            result.push(item);
          } else if (item.children) {
            const children = filterData(item.children, search);
            if (children.length > 0) {
              result.push({ ...item, children });
            }
          }
        });
        return result;
    };

    return (
        <div ref={barRef} className='bar' style={{ backgroundColor: PRIMARY_COLOR, width: (isHoveredBar) ? 420  : 50, height: "100%"}}
            onMouseEnter={handleHoveredBarEnter}
            onMouseLeave={handleHoveredBarLeave}
        >
                { !isHoveredBar && 
                    <div className='icono-barra-exp' onMouseEnter={handleMouseEnter} onClick={()=>setIsHoveredBar(true)}> 
                        <FontAwesomeIcon icon={faBars} style={{color: ICONS2}} />
                    </div>
                } 

                <div style={ !isHoveredBar ? {opacity: "0", height: "100%"} : {opacity: "1", height: "100%"}}>

               
                <div className='logo-bar' style={{ padding: ".5rem",height: "100%" }}>

                    <div
                        className='input-search-container'
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            width: "100%",
                            padding: ".2rem",
                            backgroundColor: "white",
                            color: "#3d4d87",
                            borderRadius: ".5rem",
                            overflow: "hidden",
                            
                        }}
                    >
                        <FontAwesomeIcon icon={faSearch} style={{ fontSize: "1.3rem" }} />
                        <input value={search} onChange={(event) => handlerSearch(event.target.value)} className='input-search' style={{ flex: 1, flexGrow: 1, border: "none" }} type="text" placeholder='Busque por Activo, Nivel2 o Nivel1' />
                    </div>
                    
                    <div
                        style={{ maxHeight: "90%", overflowY: "auto", color: "white", marginTop: "1rem", outline: (isHovered) ? "0px solid white" : "" }}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >

                        <TreeActivo
                            data={filterData(treeDataActivo, search) || []}
                            handleOnClick={handleOnClick}
                            showContextualMenu={showContextualMenu}
                            setShowContextualMenu={setShowContextualMenu}
                            modalToShow={modalToShow}
                            setModalToShow={setModalToShow}
                            setTreeDataActivo={setTreeDataActivo}
                            setIsHoveredBarByFlag={setIsHoveredBarByFlag}
                            canClose={canClose}
                            setCanClose={setCanClose}
                        />
                        
                    </div>

                </div>
                </div>
            </div>
    );
}

export default BarActivo